<template>
  <div class="footer">
    <div v-if="this.$vuetify.breakpoint.lgAndUp">
    <v-layout row>
      <v-flex class="ml-6">
        <ul class="footer-nav">
          <li>
            <router-link v-scroll-to="{element: '#top', duration: 1600 }" to="">Top</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/about`">{{ $t('footer.about') }}</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/contact`">{{ $t('footer.contact') }}</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/contact`">{{ $t('footer.terms') }}</router-link>
          </li>
        </ul>
      </v-flex>
      <v-flex class="ml-6">
        <ul class="social-links">
          <v-hover v-slot:default="{ hover }">
            <li>
              <a target="_blank" href="https://www.facebook.com/demunckpascal?epa=SEARCH_BOX">
                <v-icon :color="hover ? '#3b5998' : '#888'">mdi-facebook</v-icon>
              </a>
            </li>
          </v-hover>
          <v-hover v-slot:default="{ hover }">
            <li>
              <a target="_blank" href="https://www.instagram.com/pascaldemunck/">
                <v-icon :color="hover ? '#e95950' : '#888'">mdi-instagram</v-icon>
              </a>
            </li>
          </v-hover>
          <v-hover v-slot:default="{ hover }">
            <li>
              <a target="_blank" href="https://www.youtube.com/channel/UCopUCHgCXgq1683yKJuWEQQ">
                <v-icon :color="hover ? '#ff0000' : '#888'">mdi-youtube</v-icon>
              </a>
            </li>
          </v-hover>
        </ul>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <p class="mb-5">Copyright &copy; 2020 by Pascal De Munck. {{ $t('footer.copyright') }}</p>
    </v-layout>
    </div>
    <div v-else>
      <v-layout row justify-center>
      <v-flex class="ml-8">
        <ul class="footer-nav-phone">
          <li>
            <router-link v-scroll-to="{element: '#top', duration: 1600 }" to="">Top</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/about`">{{ $t('footer.about') }}</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/contact`">{{ $t('footer.contact') }}</router-link>
          </li>
        </ul>
      </v-flex>
      </v-layout>
      <v-layout row justify-center>
      <v-flex class="ml-8">
        <ul class="social-links">
          <v-hover v-slot:default="{ hover }">
            <li>
              <a target="_blank" href="https://www.facebook.com/demunckpascal?epa=SEARCH_BOX">
                <v-icon :color="hover ? '#3b5998' : '#888'">mdi-facebook</v-icon>
              </a>
            </li>
          </v-hover>
          <v-hover v-slot:default="{ hover }">
            <li>
              <a target="_blank" href="https://www.instagram.com/pascaldemunck/">
                <v-icon :color="hover ? '#e95950' : '#888'">mdi-instagram</v-icon>
              </a>
            </li>
          </v-hover>
          <v-hover v-slot:default="{ hover }">
            <li>
              <a target="_blank" href="https://www.youtube.com/channel/UCopUCHgCXgq1683yKJuWEQQ">
                <v-icon :color="hover ? '#ff0000' : '#888'">mdi-youtube</v-icon>
              </a>
            </li>
          </v-hover>
        </ul>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <p class="mb-5 ml-5">Copyright &copy; 2020 by Pascal De Munck. {{ $t('footer.copyright') }}</p>
    </v-layout>
  </div>
  </div>
</template>


<script>
export default {
  name: "Footer",
};
</script>

<style>
.footer {
  background-color: #333;
}

.footer-nav {
  list-style: none;
  margin-bottom: 50px;
  margin-left: 30%;
}

.footer p {
  font-size: 90%;
  line-height: 145%;
  color: #888;
}

.social-links {
  list-style: none;
  margin-bottom: 50px;
  margin-right: -20%;
}

.footer-nav li,
.social-links li {
  display: inline-block;
  margin-right: 20px;
  margin-top: 30px;
}
.footer-nav-phone li,
.social-links-phone li {
  display: inline-block;
  margin-right: 20px;
}

.footer-nav li a:link,
.footer-nav li a:visited,
.footer-nav-phone li a:link,
.footer-nav-phone li a:visited,
.social-links li a:link,
.social-links li a:visited,
.social-links-phone li a:link,
.social-links-phone li a:visited,
.scroll:link,
.scroll:visited {
  color: #888;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 105%;
}

.footer-nav li a:hover,
.footer-nav li a:active,
.social-links li a:hover,
.social-links li a:active {
  color: #2980b9;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 105%;
}
</style>